import React, { useEffect, useRef, useState } from "react";
import noImg from "../../../media/images/no-img.png";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch } from "react-redux";
import { setnotification } from "../../../redux/actions/styles";

const InputImage = (props) => {
  const dispatch = useDispatch();
  const { label, value, onChange, showLabel, fileSize = 1048576, helperText, className } = props;
  const imgRef = useRef();
  const [imgDisplay, setimgDisplay] = useState(value);

  useEffect(() => {
    value && setimgDisplay(value);
  }, [value]);

  function bytesToSize() {
    const KB = fileSize / 1024;
    const MB = KB / 1024;

    if (MB < 1) {
      return Math.round(KB) + " KB";
    } else {
      return Math.round(MB) + " MB";
    }
  }

  function onChangeImage(e) {
    if (e.target.files && e.target.files[0]) {
      // if (e.target.files[0].size > fileSize) {
      if (false) {
        dispatch(
          setnotification({ visible: true, text: `File size must be less than ${bytesToSize()}.`, type: "info" })
        );

        return;
      }
      const image = e.target.files[0];

      let reader = new FileReader();

      reader.onload = (e) => {
        const imageDisplay = e.target.result;
        onChange(image, imageDisplay);
        setimgDisplay(imageDisplay);
      };
      reader.readAsDataURL(image);
    }
  }
  return (
    <div className={`input-image ${imgDisplay ? "selected" : ""} ${className}`}>
      {showLabel && <p className="label">{label}</p>}
      <input type="file" accept="image/*" className="file" onChange={onChangeImage} ref={imgRef} />
      <div className="file-img" onClick={() => imgRef.current.click()}>
        <img src={imgDisplay ? imgDisplay : noImg} alt="profile" />
        <div className="info">
          <p>{label}</p>
        </div>
        <div className="add-icon">
          {imgDisplay ? <EditIcon style={{ fontSize: "1.5rem" }} /> : <AddIcon style={{ fontSize: "1.5rem" }} />}
        </div>
      </div>
      {helperText ? <p className="helper-text">{helperText}</p> : null}
    </div>
  );
};

export default InputImage;
